import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft, Search, Newspaper } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        {/* Logo stylisé comme 404 */}
        <div className="mb-8">
          <h1 className="text-6xl sm:text-[8rem] leading-none font-serif font-bold tracking-tighter">
            4<span className="text-[#D62828]">0</span>4
          </h1>
          <div className="h-1 w-24 bg-[#D62828] mx-auto rounded-full" />
        </div>

        <h2 className="text-2xl font-serif font-semibold mb-3">
          Article introuvable
        </h2>
        <p className="text-muted-foreground mb-8 leading-relaxed">
          Cette page n'existe pas ou a été déplacée. Mais ne vous inquiétez pas,
          l'actualité continue sur <span className="font-semibold">Info<span className="text-[#D62828]">Flow</span></span>.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour
          </Button>
          <Button asChild className="gap-2 bg-[#D62828] hover:bg-[#B91C1C]">
            <Link to="/">
              <Home className="h-4 w-4" />
              Page d'accueil
            </Link>
          </Button>
          <Button asChild variant="outline" className="gap-2">
            <Link to="/search">
              <Search className="h-4 w-4" />
              Rechercher
            </Link>
          </Button>
        </div>

        {/* Articles suggérés */}
        <div className="mt-12 pt-8 border-t">
          <p className="text-sm text-muted-foreground flex items-center justify-center gap-2 mb-4">
            <Newspaper className="h-4 w-4" />
            Découvrez nos derniers articles
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            {['Actualité', 'Tech & IA', 'International', 'Afrique', 'Économie'].map((cat) => (
              <Button
                key={cat}
                asChild
                variant="secondary"
                size="sm"
                className="text-xs"
              >
                <Link to={`/category/${cat.toLowerCase().replace(/[& ]+/g, '-')}`}>
                  {cat}
                </Link>
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
